<template>
  <div :class="componentClasses">
    <Title>
      Other Documents
    </Title>

    <DocMasterUploadClient
      :entity-external-id="clientPortalStore.currentEntityId"
      :advisor-slug="clientPortalStore.advisorSlug"
      :csrf-token="clientPortalStore.csrfToken"
      display-variant="other"
      @documents-updated="refreshDocuments"
      @upload-complete="handleUploadComplete"
    />

    <Stack
      v-if="clientPortalStore.otherDocuments.length"
      gap="2"
    >
      <template
        v-for="item in clientPortalStore.otherDocuments"
      >
        <Callout
          v-if="item.document"
          :key="item.id"
          spacing="loose"
        >
          <TextLink
            class="delete-link"
            :disabled="somethingIsLoading"
            variant="danger"
            size="3"
            @click="handleDeleteDocument(item.document.id, item.document.filename)"
          >
            Delete Document
          </TextLink>
          The file <strong>
            {{ item.document.filename }}</strong>
          <span v-if="item.document.uploaded_at">
            was uploaded on
            <strong>{{ formatDate(item.document.uploaded_at) }}
            </strong>
          </span>
          <span v-else>has been uploaded.</span>
        </Callout>
      </template>
    </Stack>

    <LoaderWithText v-if="clientPortalStore.isPolling">
      Processing…
    </LoaderWithText>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Button, Callout, TextLink, LoaderWithText, Stack, Title } from '@stakeui';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';
import { useDocumentUploadStore } from '@frontend/ui/stores/DocmasterStore';
import { formatDate } from '@frontend/shared/Util.js';
import DocMasterUploadClient from '@frontend/ui/features/example/components/DocMasterUploadClient.vue';

const clientPortalStore = useClientPortalStore();
const documentUploadStore = useDocumentUploadStore();

const refreshDocuments = async () => {
  try {
    // Reload checklist data
    await clientPortalStore.loadChecklistData();
  } catch (error) {
    console.error('Error refreshing documents:', error);
  }
};

const handleUploadComplete = data => {
  console.log('Upload completed:', data);
  // Start polling to see if one of the document's status changes
  clientPortalStore.startPollingChecklist();
};

const handleDeleteDocument = async (documentId, filename) => {
  if (!confirm(`Are you sure you want to delete ${filename}?`)) {
    return;
  }

  try {
    await documentUploadStore.deleteDocumentUpdateChecklist(
        clientPortalStore.currentEntityId, documentId, clientPortalStore.csrfToken,
    );
    // Start polling to see if one of the document's status changes
    clientPortalStore.startPollingChecklist();
  } catch (error) {
    console.error('Failed to delete document:', error);
  }
};

const somethingIsLoading = computed(() => documentUploadStore.isLoading);
const componentClasses = computed(() => [
  'other-documents',
]);
</script>

<style scoped>
.other-documents {
  flex-grow: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;
}

.delete-link {
  float: right;
  margin: 0 0 0.5em 1em;
}
</style>
